export default __webpack_public_path__ + "static/media/5-1820x480无糖茶.3df3d0b6.jpg";